import React from 'react';
import { Select } from 'antd';
import { SearchSelect } from '../components/SearchSelect';
import * as Styled from './styled';
import { Combinator, ErrorMessage } from '../styled';
import { isTagField, getFieldSchema, checkError } from '../utils';
import { type FieldSelectorProps, type ValidationResult } from 'react-querybuilder';
import {
  type QueryBuilderFieldSchema,
  type QueryBuilderRule,
  type QueryBuilderContext,
} from '../types';

const TagKey = (props: FieldSelectorProps) => {
  const { rule, path, schema, context, validation } = props;
  const isTag = isTagField(rule.field);
  const fieldSchema = getFieldSchema(rule.field, schema.fields as QueryBuilderFieldSchema[]);
  const { onKeyChange, showError } = context as QueryBuilderContext;

  if (!isTag) return null;
  const error = checkError(validation as ValidationResult, 'key');
  const errorMsg = showError && error ? error.message : '';

  return (
    <Styled.TagKeyContainer>
      <SearchSelect
        disabled={!fieldSchema}
        enableFreeInput
        placeholder={'Input one value'}
        className={errorMsg ? 'error-input' : ''}
        style={{ width: 180 }}
        optionFilterProp="label"
        value={(rule as QueryBuilderRule).key}
        onRemoteSearch={(value) => fieldSchema?.getTagKeyOptions?.(value)}
        onChange={(data) => {
          if (fieldSchema) {
            onKeyChange(data.value ?? null, path, fieldSchema);
          }
        }}
      />
      {errorMsg && <ErrorMessage className="error-message">{errorMsg}</ErrorMessage>}
    </Styled.TagKeyContainer>
  );
};

const DimensionField = (props: FieldSelectorProps) => {
  const { level, rule, path, schema, context } = props;
  const { groupedFields, onFieldChange } = context as QueryBuilderContext;
  const fieldSchema = getFieldSchema(rule.field, schema.fields as QueryBuilderFieldSchema[]);

  const combinator = level === 1 ? 'AND' : 'OR';
  // hidden the combinator for first rule
  const shouldHiddenCombinator = path && path[path.length - 1] === 0;
  return (
    <>
      <Combinator style={{ opacity: shouldHiddenCombinator ? 0 : 1 }}>{combinator}</Combinator>
      <Select
        showSearch
        disabled={!fieldSchema}
        style={{ width: 260 }}
        value={rule.field}
        options={groupedFields}
        filterOption={(inputValue, option) => {
          const originalLabel = String((option as any)?.originalLabel ?? '');
          return originalLabel.toLowerCase().includes(inputValue.toLowerCase());
        }}
        onChange={(field) => {
          const nextFieldSchema = getFieldSchema(field, schema.fields as QueryBuilderFieldSchema[]);
          if (nextFieldSchema) {
            onFieldChange(field, path, nextFieldSchema);
          }
        }}
      />
      <TagKey {...props} />
    </>
  );
};

export default React.memo(DimensionField);
